<template>
  <div id="examActivity">

    <ots-main-title></ots-main-title>

    <ots-table-group-new
      :messageDescript="messageDescript"
      :selectList="selectList"
      :requestForm="requestForm"
      @search="search"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      :batchOperBtn="batchOperBtn"
      @changeNum="changeNum"
      @changePage="changePage"
    ></ots-table-group-new>

    <!-- 添加试卷弹窗 -->
    <ots-custom-dialog :dialog.sync="paperDialog" title="添加试卷" width="60%">
      <template v-slot:content>
        <el-form :rules="courseRules" :model="courseForm" ref="courseForm">
          <el-form-item label="设置答卷时长" prop="examTime">
            <el-input
              class="short small-ele-input__"
              placeholder="请输入"
              v-model.number="courseForm.examTime"
            >
              <template slot="suffix">分钟</template>
            </el-input>
          </el-form-item>
          <div>
            <ots-table-group
              :tableHeader="paperTableHeader"
              :tableOption="paperTableOption"
              :tableData="paperTableData"
              @handleSelectionChange="paperBatchOper"
              :pagination="paperPagination"
              @changeNum="paperChangeSize"
              @changePage="paperChangePage"
            ></ots-table-group>
          </div>
        </el-form>
      </template>
      <template v-slot:footer>
        <el-button round @click="paperDialog = false">取消</el-button>
        <el-button round type="primary" @click="dealCoursePaper">确定</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>
<script>

import { 
  getPlanListApi, 
  getSessionListApi, 
  judgeChangeApi, 
  getCourseListApi, 
  getActivityListApi, 
  queryPaperByCourseCodeApi, 
  addPaperApi, 
  delPaperApi ,
  getWaitConfirmCountApi
} from "@/http/modules/examSet/examActivity";

import {
  getCurrentPlanFn,
} from "@/http/modules/examSet/examBatch";

export default {
  name: "examActivity",
  data() {
    return { 
      messageDescript: "",
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
          isSearch: true,
        },
        {
          title: "场次",
          type: "select",
          requestKey: "sessionId",
          label: "name",
          value: "id",
          data: [
            {name: "全部", id: ""}
          ],
        },
        {
          title: "考试课程",
          type: "select",
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          data: [
            {courseName: "全部", courseId: ""}
          ],
        },
        {
          title: "试卷状态",
          type: "select",
          requestKey: "setFlag",
          label: "name",
          value: "id",
          data: [
            {name: "未提交", id: 0},  
            {name: "已提交", id: 1},
            {name: "已更换-待确认", id: 2},
            {name: "已更换-已确认", id: 3}
          ],
        },
      ],
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "场次名称",
          prop: "sessionName",
        },
        {
          title: "考试开始时间",
          prop: "beginTime",
        },
        {
          title: "考试结束时间",
          prop: "endTime"
        },
        {
          title: "考试课程",
          prop: "courseName"
        },
        {
          title: "考试活动",
          prop: "arrangementName"
        },
        {
          title: "试卷名称",
          prop: "paperName"
        },
        {
          title: "答卷时长",
          prop: "examTime"
        },
        {
          title: "版本号",
          prop: "versionNumber"
        },
        {
          title: "试卷状态",
          prop: "stateName"
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "添加试卷",
              click: this.addPaper,
            },
          ],
        }
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      requestForm: {
        planId: "",
        sessionId: "",
        courseId: "",
        setFlag: 0,
        size: 10,
        page: 1,
      },
      waitConfirmCount: 0,
      timer: null,
      paperDialog: false,
      courseRules: {
        examTime: [{required: true, type: "number", message: "答题时长必须为数字值", trigger: "blur"}],
      },
      courseForm: {
        examTime: "",
        planId: "",
        sessionId: "",
        planCourseId: "",
        paramList: "",
      },
      currentCourse: {},
      currentSelect: [],
      paperTableHeader: [
        {
          title: "试卷名称",
          prop: "name",
        },
        {
          title: "难度",
          prop: "difficultyDegree",
        },
        {
          title: "创建日期",
          prop: "createTime",
        },
        {
          title: "课程",
          prop: "courseName",
        },
        {
          title: "使用次数",
          prop: "usedCount",
        },
        {
          title: "总分",
          prop: "score",
        },
      ],
      paperSelectList: [],
      paperTableOption: {
        multiple: true,
        selectTable: this.isCanSelectFn,
      },
      paperTableData: [],
      paperPagination: {
        total: 0,
      },
      paperListParams: {
        courseId: "",
        planId: "",
        page: 1,
        size: 10,
      },
      batchOperBtn: [],
    }
  },
  watch: {
    "requestForm.planId": "planIdChange",
    "requestForm.sessionId": "sessionIdChange",
    "requestForm.setFlag": "search"
  },
  methods: {
    /**
     * @param { 初始化数据 }
     */
    async initData() {
      const { data: planList } = await getPlanListApi()
      this.selectList[0].data = planList
      this.requestForm.planId = planList[0].id
      await this.getCourseList()
    },       

    /**
     * @param { 获取场次 }
     */
    async getSectionList() {
      const { data: secionList } =  await getSessionListApi({planId: this.requestForm.planId})
      this.selectList[1].data = [{name:"全部", id: ""}, ...secionList]
      this.requestForm.sessionId = ""
    },

    /**
     * @param { 获取考试课程 }
     */
    async getCourseList(){
      const { data: courseList } = await getCourseListApi({planId: this.requestForm.planId, sessionId: this.requestForm.sessionId})
      this.selectList[2].data = [{courseName: "全部", courseId: ""}, ...courseList]
      this.requestForm.courseId = ""
    },

    /**
     * @param { 考试批次切换 }
     */
    async planIdChange() {
      await this.getSectionList()
      await this.getCourseList()
      await this.search()
      // await this.getPlanInfo();
    },


    async getPlanInfo() {
      const res = await getCurrentPlanFn({planId: this.requestForm.planId})
      console.log(res);
    },

    /**
     * @param { 场次切换 }
     */
    sessionIdChange() {
      if (!this.requestForm.courseId) this.getCourseList()
    },

    /**
     * @param { 获取待确认数量 }
     */
    async getWaitConfirmCount() {
      if (!this.requestForm.planId) return;
      const res = await getWaitConfirmCountApi({ planId: this.requestForm.planId });
      if (res.code) {
        this.waitConfirmCount = res.data.waitConfirmCount;
        // 更新批处理按钮
        if (this.waitConfirmCount > 0) {
          this.batchOperBtn = [{
            title: `去确认`,
            icon: "el-icon-warning-outline",
            click: this.goToConfirm
          }];
          this.messageDescript = `
            <div style="background-color: #f0f5f5; border: 0px ;  padding: 12px; margin-bottom: 12px; display:; align-items: center; ">
              <p style="color: #ff8000;font-size:14px; margin-bottom: 12px;">您有<span style="color:red;font-weight:bold;"> ${this.waitConfirmCount}个 </span>场次存在待确认的试卷变更。</p>
              <p style="color: #ff8000;font-size:14px;">机房断网考试更换试卷后需要按场次确认才能生效，请及时处理！</p>
            </div>
            说明：如未确定正式考试试卷，可先添加模拟试卷。<br>1、公网考试场景下，每场正式考试开始之前可以更换为正式考试试卷<br>2、机房版断网考试场景下，每场正式考试开始前 2 小时可更换为正式考试试卷。
          `;
        } else {
          this.batchOperBtn = [];
          this.messageDescript = "说明：如未确定正式考试试卷，可先添加模拟试卷。<br>1、公网考试场景下，每场正式考试开始之前可以更换为正式考试试卷<br>2、机房版断网考试场景下，每场正式考试开始前 2 小时可更换为正式考试试卷。";
        }
      }
    },

    /**
     * @param { 获取查询结果 }
     */
    async search() {
      let param = {...this.requestForm}
      let res = await getActivityListApi(param)
      if (res.code) {
        this.tableData = res.data
      }

      await this.setFlagChange()
      await this.getWaitConfirmCount()
    },

    /**
     * @param { 添加试卷 }
     */
    async addPaper(row) {
      // (1) 是否可执行"添加试卷"操作
      const { code } = await judgeChangeApi({ 
        planId: row.planId, 
        sessionId: row.sessionId , 
        action : "add" 
      })
      if (code != 1) return

      //如果row.sessionVersionId不是空，并且row.confirmState=1，并且row.executeState不等于2，则不能添加试卷
      if (row.sessionVersionId && row.confirmState == 1 && row.executeState != 2) {
        this.$message.warning("该场次已确认并且尚未完成试卷更新，不能再次替换试卷！")
        return
      }

      const { setFlag } = this.requestForm
      if (setFlag) {
        this.$message.success("正在为您查询可编辑的试卷，请耐心等待。")
      } else {
        this.$message.success("正在为您查询可添加的试卷，请耐心等待。")
      }

      // 配置时间
      const { beginTime, endTime } = row;
      let beginTimeStamp = new Date(beginTime).getTime();
      let endTimeStamp = new Date(endTime).getTime();
      let examTime = parseInt( (endTimeStamp - beginTimeStamp) / 60000 );
      this.courseForm.examTime = examTime;

      // (2) 获取 "试卷列表"
      let param = {...this.paperListParams}
      param.courseId = row.courseIds
      param.planId = row.planId
      const { data } = await queryPaperByCourseCodeApi(param)
      this.paperTableData = data.papers
      this.paperDialog = true
      // (3) 获取当前选中课程场次
      this.currentCourse = row
      // (4) 重置时间
      // this.courseForm.examTime = ''
    },

    /**
     * @param { 执行添加试卷, 前置功能, 参数处理 }
     */
    dealCoursePaper() {
      this.$refs["courseForm"].validate(async (valid) => {
        if (valid) {
          if (this.currentSelect.length == 0) {
            this.$message.warning("请先勾选要设置的试卷！")
            return
          }
          const { courseName, planId, sessionId, planCourseId } = this.currentCourse
          let paramList = []
          this.currentSelect.map(e=>{
            let item = {
              planCourseId,
              courseName,
              paperId: e.id,
              paperName: e.name,
              examTime: this.courseForm.examTime,
              judgementMode: e.judgementMode
            }
            paramList.push(item)
          })
          let params = {
            planId,
            sessionId,
            planCourseId,
            paramList: JSON.stringify(paramList)
          }
          const { code } = await addPaperApi(params)

          if (code == 1)  {
            const { setFlag } = this.requestForm
            if (setFlag) {
              this.$message.success("试卷编辑成功！")
            } else {
              this.$message.success("试卷添加成功！")
            }
          }
          this.search()
          this.paperDialog = false
        }
      });
    },

    /**
     * @param { 添加试卷是否禁用勾选 }
     */
    isCanSelectFn(row) {
      let paperId = this.currentCourse.paperId.split(",")
      return !paperId.includes(row.id)
    },

    /**
     * @param { 删除试卷 }
     */
    deletePaper(row) {
      this.$confirm("确定要删除试卷吗？", "删除试卷", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then( async () => {
        const { planId, sessionId, planCourseId } = row
        let param = { planCourseId, planId, sessionId }
        const { code } = await delPaperApi(param)
        if (code) this.$message.success("试卷删除成功！")
        this.search()
      }).catch(() => {});
    },

    /**
     * @param { 是否设置考试活动 ==> 修改操作按钮 }
     */
    setFlagChange() {
      const { setFlag } = this.requestForm

      if (setFlag) {
        this.tableHeader[this.tableHeader.length-1].btnList = [
          {
            title: "编辑试卷",
            click: this.addPaper,
          },
          {
            title: "删除试卷",
            click: this.deletePaper
          }
        ]
      } else {
        this.tableHeader[this.tableHeader.length-1].btnList = [
          {
            title: "添加试卷",
            click: this.addPaper,
          },
        ]
      }

      // this.tableHeader[this.tableHeader.length-1].btnList[0].title = setFlag ? "删除试卷" : "添加试卷"
      // this.tableHeader[this.tableHeader.length-1].btnList[0].click = setFlag ? this.deletePaper : this.addPaper
    },

    /**
     * @param { 添加试卷勾选项 }
     */
    paperBatchOper(val) {
      this.currentSelect = val
    },

    changeNum(num) {
      this.requestForm.size = num;
      this.search();
    },

    changePage(p) {
      this.requestForm.page = p;
      this.search();
    },

    paperChangeSize(num) {
      this.paperListParams.size = num;
      this.getPaper();
    },

    paperChangePage(p) {
      this.paperListParams.page = p;
      this.getPaper();
    },

    /**
     * @param { 跳转到确认页面 }
     */
    goToConfirm() {
      this.$router.push({name: 'confirmChangePaper', query: { planId: this.requestForm.planId }});
    },

  },
  mounted() {
    this.initData();
    /* 
        场次设置的考试起止时间同步给场次下的活动答卷时长    
    */


    // 设置定时器，每30秒查询一次待确认数量
    this.timer = setInterval(() => {
      this.getWaitConfirmCount();
    }, 30000);
  },
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
}
</script>
<style scoped lang="less">

</style>